/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import React from 'react'
import { Link } from 'react-router-dom'
import { ROUTES } from '@sportninja/common/constants/app'
import colors from '@sportninja/common/constants/appColors'
import { weightBold } from 'src/components/css'
import Text from '../ts-components/Text'

const bannerContainerStyles = css`
  width: 100%;
  padding: 8px;
  background-color: ${colors.SECONDARY_400};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
`

const boldTextStyles = css`
  ${weightBold}
`

const buttonsContainerStyles = css`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
`

const upgradeButtonStyles = css`
  flex: 1;
  padding: 8px;
  background-color: ${colors.AMERICAN_YELLOW};
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`

const demoButtonStyles = css`
  flex: 1;
  padding: 8px;
  border-radius: 8px;
  border: 1px solid ${colors.PRIMARY};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`

const onboardingButtonStyles = css`
  flex: 1;
  padding: 8px;
  border-radius: 8px;
  border: 1px solid ${colors.NEUTRAL_0};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  cursor: pointer;
  color: ${colors.NEUTRAL_0};
  width: 100%;

  &:hover {
    opacity: 0.9;
  }
`

const UpgradeBanner: React.FC = () => {
  return (
    <div css={bannerContainerStyles}>
      <Text variant='paragraphXSmall' weight='regular' color={colors.NEUTRAL_0}>
        You are using a <span css={boldTextStyles}>Free Account</span>. <br />
        <b>Upgrade now</b> to unlock the full experience and keep all features.
      </Text>
      <div css={buttonsContainerStyles}>
        <Link
          to={ROUTES.GENERAL_SETTINGS + '?origin=subscription'}
          css={upgradeButtonStyles}
        >
          <Text
            variant='paragraphXSmall'
            weight='regular'
            color={colors.SECONDARY_300}
          >
            Upgrade Now
          </Text>
        </Link>
        <a
          href='https://info.sportninja.com/meetings/james-goodfellow'
          target='_blank'
          rel='noopener noreferrer'
          css={demoButtonStyles}
        >
          <Text
            variant='paragraphXSmall'
            weight='regular'
            color={colors.PRIMARY}
          >
            Book a Demo
          </Text>
        </a>
      </div>
      <a
        href='https://info.sportninja.com/meetings/james-goodfellow/onboarding-and-product-qa'
        target='_blank'
        rel='noopener noreferrer'
        css={onboardingButtonStyles}
      >
        <Text
          variant='paragraphXSmall'
          weight='regular'
          color={colors.NEUTRAL_0}
        >
          Meet with Onboarding Specialist
        </Text>
      </a>
    </div>
  )
}

export default UpgradeBanner
